<template>
  <div>
    <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

    <div style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden">
      <userLeft :active="3" />
      <div class="box5" style="position: relative">
        <div style="overflow: hidden">
          <div class="box6" style="float: left">收货地址</div>
        </div>
        <div class="box7"></div>

        <div style="overflow: hidden">
          <div class="box6" style="float: left; color: #2b9a34; margin-top: 20px">
            +新增收货地址
          </div>
        </div>

        <div style="
                width: 100%;
                border: 1px solid #ede9e9;
                margin-top: 20px;
                overflow: hidden;
                padding-bottom: 20px;
              ">
          <div style="overflow: hidden; margin-top: 2%">
            <div class="item_title">
              <span style="color: red">*</span> 收货人：
            </div>
            <a-input v-model="obj.userName" placeholder="请输入收货人" style="
                    float: left;
                    width: 300px;
                    margin-left: 20px;
                    margin-top: 10px;
                  " />
          </div>

          <div style="overflow: hidden; margin-top: 2%">
            <div class="item_title">
              <span style="color: red">*</span> 所在地区：
            </div>
            <div style="overflow: hidden">
              <!-- <a-select :default-value="obj.province ? obj.province : '请选择省'" @change="sheng_Change"> -->
              <a-select :value="obj.province ? obj.province : '请选择省'" @change="sheng_Change">
                <a-select-option :key="index" v-for="(item, index) in all_available" :value="item.name">
                  {{ item.name }}
                </a-select-option>
              </a-select>
              <a-select :value="obj.city ? obj.city : '请选择市'" default-value="请选择市" @change="shi_Change">
                <a-select-option :key="index" v-for="(item, index) in all_shi" :value="item.name">
                  {{ item.name }}
                </a-select-option>
              </a-select>
              <a-select :value="obj.area ? obj.area : '请选择区'" default-value="请选择区" @change="qu_Change">
                <a-select-option :key="index" v-for="(item, index) in all_qu" :value="item.name">
                  {{ item.name }}
                </a-select-option>
              </a-select>
              <a-select v-if="sanhuan_show" placeholder="请选择三环内/三环外" v-model="obj.ring" style="width: 120px">
                <a-select-option value="INNER">
                  三环内
                </a-select-option>
                <a-select-option value="OUTER">
                  三环外
                </a-select-option>
              </a-select>
            </div>
          </div>
          <div style="position:relative">
            <div style="overflow: hidden; margin-top: 2%">
              <div class="item_title">
                <span style="color: red">*</span> 详细地址：
              </div>
              <a-input v-model="obj.detailAddress" @change="getsuggest" @blur="clearSug" placeholder="请输入详细地址" style="
                      float: left;
                      width: 300px;
                      margin-left: 20px;
                      margin-top: 10px;
                    " />
            </div>
            <div class="addressList" v-if="addressList.length > 0">
              <div v-for="item in addressList" :key="item.id" class="addressItem" @click="selectAddress(item)">
                <div class="title">{{ item.title }}</div>
                <div class="address">{{ item.address }}</div>
              </div>
            </div>
          </div>
          <div style="overflow: hidden; margin-top: 2%">
            <div class="item_title">
              详细地址备注：
            </div>
            <a-input v-model="obj.remarks" placeholder="可以输入单元/楼层/门牌号等" style="
                    float: left;
                    width: 300px;
                    margin-left: 20px;
                    margin-top: 10px;
                  " />
          </div>

          <div style="overflow: hidden; margin-top: 2%">
            <div class="item_title">
              <span style="color: red">*</span> 手机号码：
            </div>
            <a-input v-model="obj.userNum" placeholder="请输入手机号码" style="
                    float: left;
                    width: 300px;
                    margin-left: 20px;
                    margin-top: 10px;
                  " />
          </div>

          <div style="overflow: hidden; margin-top: 2%">
            <div class="item_title">
              <span style="color: red"></span> 固定电话：
            </div>
            <div style="overflow: hidden">
              <a-input v-model="obj.areaCode" placeholder="区号" style="
                      float: left;
                      width: 85px;
                      margin-left: 20px;
                      margin-top: 10px;
                    " />
              <a-input v-model="obj.landlineNum" placeholder="座机号" style="
                      float: left;
                      width: 85px;
                      margin-left: 20px;
                      margin-top: 10px;
                    " />
              <a-input v-model="obj.extNum" placeholder="座机分号" style="
                      float: left;
                      width: 85px;
                      margin-left: 20px;
                      margin-top: 10px;
                    " />
            </div>
          </div>

          <div style="overflow: hidden; margin-top: 2%">
            <div class="item_title">
              <span style="color: red"></span> 电子邮箱：
            </div>
            <a-input v-model="obj.email" placeholder="请输入电子邮箱" style="
                    float: left;
                    width: 300px;
                    margin-left: 20px;
                    margin-top: 10px;
                  " />
          </div>

          <div style="overflow: hidden; margin-top: 2%">
            <div class="item_title"><span style="color: red"></span></div>
            <a-checkbox @change="defaultAddress_onChange" v-model="obj.defaultAddress" style="margin-left: 20px">
              设为默认
            </a-checkbox>
          </div>

          <div style="overflow: hidden; margin-top: 2%">
            <div class="item_title"><span style="color: red"></span></div>
            <div style="overflow: hidden; margin-left: 20px">
              <div class="tianjia_but1" @click="add_address_but" style="cursor: pointer;margin-left: 20px;">
                添加
              </div>
              <div @click="quxiao" style="
                      float: left;
                      margin-left: 20px;
                      font-size: 14px;
                      color: #333333;
                      margin-top: 10px;
                      cursor: pointer;
                    ">
                取消
              </div>
            </div>
          </div>
        </div>

        <div style="overflow: hidden">
          <div class="box12">
            <div class="box13" style="padding-left: 10px; line-height: 40px;width:20%">
              收货人
            </div>
            <div class="box13" style="line-height: 40px;width:35%">收货地址</div>
            <div class="box13" style="line-height: 40px;width:25%">联系方式</div>
            <div class="box13" style="line-height: 40px;width:20%">操作</div>
          </div>
          <template v-if="data_list.length > 0">

            <div class="box12" style="
                  margin-top: 0;
                  background: none;
                  border-bottom: 1px solid #eeeeee;
                  height: 60px;
                " :key="index" v-for="(item, index) in data_list">
              <div class="box13" style="padding-left: 10px;width:20%">
                {{ item.userName }}
              </div>
              <div class="box13" style="word-break: break-all;line-height: 30px;width:35%">
                {{ item.province + "/" + item.city + "/" + item.area }}</br>
                {{ item.detailAddress }}
              </div>
              <div class="box13" style="padding-right: 10px; color: #999;width:25%">
                <div style="float: left">
                  <div style="line-height: 30px">{{ item.userNum }}</div>
                  <div style="line-height: 30px">
                    {{ item.areaCode }} - {{ item.landlineNum }} -
                    {{ item.extNum }}
                  </div>
                </div>
                <div class="morendizhi" v-if="item.defaultAddress == 1">
                  默认地址
                </div>
              </div>
              <div class="box13" style="padding-right: 10px; color: #999;width:20%">
                <a-row>
                  <a-col :span="12" style="color: #2b9a34; cursor: pointer" @click="shezhimoren(item)">
                    {{ item.defaultAddress ? '取消默认设置' : '设为默认地址' }}
                  </a-col>
                  <a-col style="cursor: pointer" :span="6" @click="editAddress(item)">
                    修改
                  </a-col>
                  <a-col style="cursor: pointer" :span="6" @click="dakaishanchu(item.uuid)">
                    删除
                  </a-col>
                </a-row>
              </div>
            </div>
          </template>
          <div v-if="data_list.length == 0" style="text-align: center; margin-top: 20px">
            您的地址为空 ~
          </div>
        </div>
      </div>
    </div>
    <foot />

    <a-modal centered :visible="visible" :footer="null" :width="480" :height="240">
      <div class="pop_title">删除这个地址吗?</div>
      <div style="overflow: hidden; width: 50%; margin: 20px auto">
        <div class="pop_left_bue" @click="shanchudizhi">确定</div>
        <div @click="visible = false" class="pop_left_bue" style="
                float: right;
                border: 1px solid #ede9e9;
                color: #666;
                background: #fff;
              ">
          取消
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import userLeft from "../public/user_left";
import htmlHeader from "../public/head";
import foot from "../public/foot";
export default {
  name: "integral",
  components: {
    userLeft,
    htmlHeader,
    foot,
  },
  data() {
    return {
      addressList: [],

      sanhuan_show: false, //是否显示三环
      shanchu_id: null, // 待删除地址id
      all_shi: "", // 下级市
      all_qu: "", // 下级区
      all_qu2: "", // 三环内
      all_available: "", // 所有省份
      visible: false, // 删除弹框
      data_list: [], // 我的地址
      obj: {
        lng: '',
        lat: '',
        areaId: '',
        area: "", //区
        areaCode: "", //区号
        city: "", //市
        defaultAddress: false, //默认地址 1为默认0为非默认
        detailAddress: "", //详细地址
        email: "", //电子邮箱
        extNum: "", //座分机号
        landlineNum: "", //座机号
        province: "", //省
        userId: localStorage.username, //用户uuid
        userName: "", //用户名
        userNum: "", //用户电话
        remarks: "",
        // ring: '',
      }, // 提交地址数据
      sanhuan_show: false, //是否显示三环
    };
  },
  methods: {
    //选择详细地址
    selectAddress(item) {
      console.log(item, '我现在已经拿到了111111111111111111111111111');
      // this.obj.remarks = item.address
      this.obj.detailAddress = item.title;
      this.obj.lat = item.location.lat;
      this.obj.lng = item.location.lng;
      this.addressList = [];
    },
    clearSug() {
      this.obj.detailAddress = ''
    },
    //触发关键词输入提示事件
    /**
     * @param {输入值} e
     */
    getsuggest: function (e) {
      let region = '';
      if (this.obj.city) {
        region = this.obj.city;
      }
      //在执行这一步之前要配置跨域，不然会报错
      this.api
        .getAddress({
          keyword: this.obj.detailAddress, //关键字
          region, //当前城市
          key: '5YNBZ-WKXWJ-R2PF5-KLOUP-3SISF-TLFHH' //你申请的key
        })
        .then(res => {
          console.log(JSON.parse(res.message), 'ddddddddddddddddddddddd');
          if (JSON.parse(res.message).data.length === 0) {
            this.$message.error('您输入的地址未能匹配，请重新输入真确的地址')
            this.form.freightRule.address = ''
          }
          this.addressList = JSON.parse(res.message).data;
        })
        .catch(err => {
          console.log(err);
          this.$message.error('请求超时');
        });
    },
    // 取消
    quxiao() {

    },
    // 编辑地址
    editAddress(e) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.obj = e;
      this.all_available.forEach((element) => {
        if (element.name == e.province) {
          this.all_shi = element.children;
        }
      })
      if (e.city == '成都市') {
        this.sanhuan_show = true;
        this.obj.ring = e.ring;
      } else {
        this.sanhuan_show = false;

      }
      this.obj = e;
      this.all_available.forEach((element) => {
        if (element.name == e.province) {
          this.all_shi = element.children;
        }
      });
      this.all_shi.forEach((element) => {
        if (element.name == e.city) {
          this.all_qu = element.children;
        }
      });

    },
    // 改变列表的默认
    shezhimoren(e) {
      const that = this;
      that.$confirm({
        title: `${e.defaultAddress ? '取消默认设置吗?' : '设置为默认吗?'}`,
        okText: "确定",
        cancelText: "取消",
        onOk() {
          if (e.defaultAddress) {
            that.api.cancelAddress(e.uuid).then((res) => {
              that.$message.success("操作成功");
              that.get_my_address();
            })
          } else {
            that.api.defaultAddress(e.uuid).then((res) => {
              that.$message.success("操作成功");
              that.get_my_address();
            })
          }
        },
      });
    },
    // 删除弹框
    dakaishanchu(e) {
      this.shanchu_id = e;
      this.visible = true;
    },
    // 确定删除地址
    shanchudizhi() {
      this.api.deleteAddress(this.shanchu_id).then((res) => {
        this.visible = false;
        this.$message.success("操作成功");
        this.get_my_address();
      });
    },

    // 切换默认地址
    defaultAddress_onChange(e) {
      this.obj.defaultAddress = e.target.checked
    },

    // 提交数据
    add_address_but() {
      if (
        this.obj.area == '' ||
        this.obj.city == '' ||
        this.obj.detailAddress == '' ||
        this.obj.province == '' ||
        this.obj.userName == '' ||
        this.obj.userNum == '') {
        this.$message.error("请填写完整");
        return false;
      }
      if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.obj.userNum)) {
        this.$message.error("请输入正确的手机号");
        return false;
      }

      // let isMob=/^0\d{2,3}-?\d{7,8}$/
      // let _isMob = this.obj.areaCode + this.obj.landlineNum + this.obj.extNum
      // if(isMob.test(_isMob)){
      //   this.$message.error("请输入正确的座机号");
      //   return false;
      // }
      // console.log(_isMob);
      // return

      this.obj.defaultAddress = this.obj.defaultAddress ? "1" : "0";
      this.api.createOrUpdate(this.obj).then((res) => {
        if (res.ok) {
          this.get_my_address();
          this.$message.success("操作成功");
          this.clear_from()
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 清除表单
    clear_from() {
      this.obj.area = "" //区
      this.obj.areaCode = "" //区号
      this.obj.city = "" //市
      this.obj.defaultAddress = false //默认地址 1为默认0为非默认
      this.obj.detailAddress = "" //详细地址
      this.obj.email = "" //电子邮箱
      this.obj.extNum = "" //座分机号
      this.obj.landlineNum = "" //座机号
      this.obj.province = "" //省
      this.obj.userId = localStorage.username //用户uuid
      this.obj.userName = "" //用户名
      this.obj.userNum = "" //用户电话
      this.obj.uuid = null //用户电话

    },

    // 切换地址
    sheng_Change(e) {
      this.obj.province = e;
      this.obj.city = ''
      this.obj.area = ''
      delete (this.obj['ring'])
      this.all_available.forEach((element) => {
        if (element.name == e) {
          this.all_shi = element.children;
        }
      });
    },
    shi_Change(e) {
      this.obj.city = e;
      this.obj.area = ''
      this.all_shi.forEach((element) => {
        if (element.name == e) {
          this.all_qu = element.children;
          if (element.name == '成都市') {
            this.obj.ring = ''
            this.sanhuan_show = true
          } else {
            this.sanhuan_show = false
            delete (this.obj['ring'])
          }
        }
      });
    },
    qu_Change(e) {
      this.obj.area = e;
      console.log(this.obj.area);
      this.all_qu.forEach((element) => {
        if (element.name == e) {
          this.obj.areaId = element.id;
          this.all_qu2 = element.children;

        }
      });
    },
    qu1_Change(e) {
      if (e == '三环内') {
        this.obj.ring = 'INNER'
      } else {
        this.obj.ring = 'OUTER'
      }
    },

    // 我的地址列表
    get_my_address() {
      this.api.get_address().then((res) => {
        this.data_list = res.data;
      });
    },
  },
  created() {
    this.get_my_address();
    // 获取地址资源
    this.api.get_all_available().then((res) => {
      this.all_available = res.data;
    });
  },
};
</script>

<style scoped>
.morendizhi {
  width: 60px;
  height: 18px;
  background: #f24145;
  float: left;
  text-align: center;
  line-height: 18px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  margin-left: 10px;
  margin-top: 20px;
}

.ant-input {}

.ant-select {
  float: left;
  width: 150px;
  margin-left: 20px;
  margin-top: 10px;
}

.pop_tisp {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  text-align: center;
  margin-top: 20px;
}

.pop_left_bue {
  width: 100px;
  height: 40px;
  background: #2b9a34;
  float: left;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.pop_title {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 20px;
  text-align: center;
}

.tianjia_but1 {
  width: 100px;
  height: 32px;
  background: #2b9a34;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  float: left;
}

.item_title {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 42px;
  text-align: right;
  float: left;
  margin-top: 5px;
  width: 20%;
}

.shangyiye {
  width: 100px;
  height: 32px;
  border: 1px solid #ede9e9;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  float: left;
}

.ant-select-selection {
  background: #f4f4f4 !important;
}

.box14 {
  width: 120px;
  height: 32px;
  border: 1px solid #2c9a34;
  float: right;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2c9a34;
}

.box13 {
  width: 25%;
  height: 100%;
  float: left;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-spacing: normal;
}

.box12 {
  width: 100%;
  height: 40px;
  background: #f4f4f4;
  margin-top: 4%;
}

.box11 {
  width: 100px;
  height: 32px;
  border: 1px solid #2b9a34;
  margin: 8% auto;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2b9a34;
}

.box10 {
  font-size: 40px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ff9629;
  /* line-height: 16px; */
  margin: 4% auto;
}

.box9 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  margin: auto;
}

.box8 {
  width: 100%;
  height: 105px;
  background: EEF7EF;
  /* opacity: 0.08; */
  padding-top: 4%;
}

.box7 {
  width: 100%;
  height: 1px;
  border-top: 1px solid #e8e6e6;
  margin-top: 2%;
}

.box6 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  /* margin-top: 2%; */
  text-align: left;
}

.box5 {
  width: 80%;
  border: 1px solid #ede9e9;
  float: right;
  margin-top: 2%;
  padding: 2%;
}

.box3 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: Regular;
  color: #666666;
  margin-top: 6%;
}

.box4 {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}

.box1 {
  width: 220px;
  min-height: 1023px;
  border: 1px solid #ede9e9;
  float: left;
  margin-top: 2%;
}

.box2 {
  width: 100%;
  height: 45px;
  background: #f2f2f2;
}

.addressList {
  background-color: #fff;
  padding: 10px;
  padding-bottom: 0;
  margin-top: 5px;
  border: 1px solid #d9d9d9;
  position: absolute;
  top: 42px;
  left: 200px;
  z-index: 99;
  max-height: 249px;
  min-width: 365px;
  overflow-y: auto;
}

.addressItem {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
  margin-bottom: 10px;
  cursor: default;
}

.addressItem>.title {
  color: #666;
}

.addressItem:hover {
  color: #2b9a34;
}

.addressItem:hover>.title {
  color: #2b9a34;
}
</style>



// WEBPACK FOOTER //
// src/components/address_list.vue